// The option shape used by react-select (ours) and by fishfood's dropdowns (which still bundle react-select 1).
export type OptionValues = string | number | boolean;

export interface SelectOption<T = OptionValues> {
  label: string;
  value: T;
}

// react-select 1 took the plain value(s) and looked the option up itself; react-select 5 wants the option object(s).
// A value that is not (yet) among the options shows nothing, as before.
export const findOption = <T>(options: readonly SelectOption<T>[] | null | undefined, value: T) =>
  (options && options.find(o => o.value === value)) || null;

export const findOptions = <T>(options: readonly SelectOption<T>[] | null | undefined, values: readonly T[] | null) =>
  (values || []).map(v => findOption(options, v)).filter(o => o != null);
